import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  multiline?: boolean
  rows?: number
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  multiline: true
}

type CombinedProps = InputProps | TextareaProps

export const Input: React.FC<CombinedProps> = ({ 
  className = '', 
  label, 
  error, 
  multiline, 
  rows = 3,
  ...props 
}) => {
  const baseClassName = `block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
    error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300'
  } ${className}`

  const inputElement = multiline ? (
    <textarea
      className={baseClassName}
      rows={rows}
      {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
    />
  ) : (
    <input
      className={baseClassName}
      {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
    />
  )

  if (!label && !error) {
    return inputElement
  }

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      {inputElement}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
}